/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formposition_Label1Inputs */

const ja_contact_formposition_label1 = /** @type {(inputs: Contact_Formposition_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`応募したいポジションを選択してください`)
};

const en_contact_formposition_label1 = /** @type {(inputs: Contact_Formposition_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which Position would you like to apply for?`)
};

/**
* | output |
* | --- |
* | "Which Position would you like to apply for?" |
*
* @param {Contact_Formposition_Label1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formposition_label1 = /** @type {((inputs?: Contact_Formposition_Label1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formposition_Label1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formposition_label1(inputs)
	return en_contact_formposition_label1(inputs)
});
export { contact_formposition_label1 as "contact_formPosition_label" }